import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaChevronRight, FaInfoCircle, FaUniversity, FaMicroscope, FaFlask, FaExternalLinkAlt, FaFilePdf } from 'react-icons/fa';
import NotificationBar from '../../components/NotificationBar/NotificationBar';
import './Home.css';

const Home = () => {
  const importantDates = [
    { event: 'Abstract Submission Starts', date: '1 March 2026' },
    { event: 'Submission Closes', date: '29 May 2026' },
    { event: 'Acceptance Notification', date: '30 May 2026' },
    { event: 'Regular Registration Closes', date: '07 June 2026, 11:59 PM IST' },
    { event: 'Late Registration', date: 'After 07 June 2026, 11:59 PM IST' },
    { event: 'Conference Dates', date: '11-12 June 2026' },
  ];
  const sponsorLogos = [
    { name: 'ANRF', logo: '/ANRF.jpg' },
    { name: 'CSIR', logo: '/csir.png' },
    { name: 'Nuclotech Solutions', logo: '/nucleotech.png' },
    { name: 'Holmarc Opto-Mechatronics', logo: '/holmarc.png' },
    { name: 'Pfeiffer Vacuum', logo: '/pfieffer.png' },
    { name: 'Ants Innovations', logo: '/ants.png' },
    { name: 'Infinity Systems', logo: '/Infinity_Logo.png' },
    { name: 'Labquip', logo: '/labquip.png' },
    { name: 'VB Ceramics', logo: '/vbceramics.png' },
    { name: 'Canara Bank', logo: '/canara.jpg' },
    { name: 'IR Tech', logo: '/irtech.jpg' },
  ];

  const conferenceThemes = [
    {
      title: 'Energy and Sustainable Materials',
      description: 'Super Capacitors / Solar Cells / Batteries / Hydrogen Fuel Production & Storage / Renewable Energy Materials'
    },
    {
      title: 'Advanced Methods In Materials',
      description: 'Single Crystals / Thin Films / Nanomaterials / Materials for Additive Manufacturing / Alloys and Composites'
    },
    {
      title: 'Computational Modelling and Simulation in Materials',
      description: 'AI & ML for Materials'
    },
    {
      title: 'Advanced Materials',
      description: 'Electronic conducting Materials / Dielectric, Ferroelectric and Piezoelectric Materials / Lasers, Optical Materials & Photonic Devices / Magnetic & Superconducting Materials and Devices'
    }
  ];

  return (
    <div className="home-page">
      {/* Notification Bar */}
      <NotificationBar />

      {/* Schedule Announcement Banner */}
      <section className="schedule-announcement-banner">
        <div className="schedule-announcement-inner">
          <span className="schedule-announcement-icon">&#9888;</span>
          <div className="schedule-announcement-text">
            <p className="schedule-announcement-main blink-text">
              The Technical Programme Schedule is now available! Click below to view or download.
            </p>
            <p className="schedule-announcement-note">
              <strong>Note:</strong>&nbsp;
              1. Dimensions of the Poster: <strong>60 cm &times; 90 cm</strong>.&nbsp;&nbsp;
              2. Oral Presentation should be within <strong>12–15 Slides (10 min duration)</strong>.
            </p>
          </div>
          <a
            href="/Technical_Programme_Final.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="schedule-announcement-pdf-btn"
          >
            <FaFilePdf /> View Schedule
          </a>
        </div>
      </section>

      {/* Publication Announcement Section */}
      <section className="home-publication-announcement">
        <div className="announcement-content">
          <p className="announcement-text">
            Selected papers of NCAMST-2026 will be published in <strong>AIP Conference Proceedings</strong>, after peer review.
          </p>
        </div>
      </section>

      {/* Hero Section */}
      <section className="home-hero">
        <div className="home-hero-overlay"></div>
        <div className="home-container home-hero-content">
          {/* Top Section: Logos + Title */}
          <div className="home-hero-top-section">
            <img src="/iiitlogo.png" alt="IIITDM Kurnool" className="home-hero-side-logo home-hero-logo-left" />

            <div className="home-hero-title-block">
              <p className="home-hero-sponsored">DST-ANRF and CSIR Sponsored</p>
              <h4 className="home-hero-subtitle">National Conference on</h4>
              <h1 className="home-hero-title">Advanced Materials for Sustainable Technologies</h1>
              <h2 className="home-hero-shortform">(NCAMST-2026)</h2>
            </div>

            <img src="/decennial.png" alt="Decennial Celebration" className="home-hero-side-logo home-hero-logo-right" />
          </div>

          {/* Bottom Section: 3-Column Row */}
          <div className="home-hero-bottom-section">
            {/* Left: Conference Date Card */}
            <div className="home-hero-card home-conference-date-card" aria-label="Conference calendar">
              <div className="home-hero-card-header">
                <FaCalendarAlt className="home-hero-card-icon" />
                <span>Conference Dates</span>
              </div>
              <div className="home-hero-card-content">
                <p className="home-conference-date">11-12 June 2026</p>
                <p className="home-conference-venue">IIITDM Kurnool</p>
              </div>
            </div>

            {/* Center: Download Brochure Button */}
            <div className="home-hero-button-wrapper">
              <a href="/brochure.pdf" className="home-btn-download-brochure" target="_blank" rel="noopener noreferrer">
                Download Brochure
              </a>
            </div>

            {/* Right: Important Dates Card */}
            <div className="home-hero-card home-important-dates-card" aria-label="Important dates">
              <div className="home-hero-card-header">
                <h4 className="home-hero-card-title">Important Dates</h4>
              </div>
              <div className="home-hero-card-content home-dates-list">
                {importantDates.slice(0, 6).map((item, index) => (
                  <p className="home-date-item" key={index}>
                    <span className="home-date-event">{item.event}</span>
                    <span className="home-date-value">{item.date}</span>
                  </p>
                ))}
              </div>
              <div className="home-venue-info">
                <p className="home-venue-label"><strong>Venue:</strong> Department of Sciences (DOS)</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sponsors Marquee */}
      <section className="sponsors-marquee-section">
        <p className="sponsors-marquee-label">Supported &amp; Sponsored By</p>
        <div className="sponsors-track-wrapper">
          <div className="sponsors-track">
            {[...sponsorLogos, ...sponsorLogos].map((s, i) => (
              <div className="sponsor-marquee-item" key={i}>
                <img src={s.logo} alt={s.name} title={s.name} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Conference */}
      <section className="home-section home-about-conference">
        <div className="home-container">
          <div className="home-section-header">
            <h2 className="home-section-title">Scope of The Conference</h2>
          </div>
          <div className="home-content-grid">
            <div className="home-text-content">
              <p className="home-lead-text">The National Conference on Advanced Materials for Sustainable Technologies will be held at the Indian Institute of Information Technology Design and Manufacturing, Kurnool, Andhra Pradesh, during June 11- 12, 2026.</p>
              <p className="home-text-paragraph home-text-justified">Advanced materials are deliberately designed to exhibit application-specific functionalities enabled by breakthroughs in quantum-level understanding of matter. Spanning from bulk to nanoscale systems, these engineered materials possess fine-tuned properties essential for low-power electronics, green computing, energy storage, and other applications to achieve sustainability goals such as reduced carbon footprint, recyclability, and cost-effectiveness. This conference aims to equip faculty and researchers with frontier knowledge on the fundamentals, processing techniques, and applications of advanced materials.</p>
              <p className="home-text-paragraph home-text-justified">The scientific deliberations at the conference will cover keynote talks by eminent Scientists, invited talks by experts, and presentations by faculty, researchers, PhD scholars, and students.</p>
            </div>
            <div className="home-themes-column">
              <h4 className="home-themes-subtitle">Conference Themes</h4>
              <div className="home-themes-list">
                {conferenceThemes.map((theme, index) => (
                  <div className="home-theme-item" key={index}>
                    <h5 className="home-theme-item-title">{theme.title}</h5>
                    <p className="home-theme-item-description">{theme.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About IIITDM Kurnool */}
      <section className="home-section home-about-iiitdm home-bg-light">
        <div className="home-container">
          <div className="home-section-header">
            <h2 className="home-section-title">
              About IIITDM Kurnool
              <a href="https://iiitk.ac.in" target="_blank" rel="noopener noreferrer" className="home-external-link" title="Visit IIITDM Website">
                <FaExternalLinkAlt />
              </a>
            </h2>
          </div>
          <div className="home-content-grid home-content-grid-reverse">
            <div className="home-text-content">
              <p className="home-text-paragraph home-text-justified">Indian Institute of Information Technology Design and Manufacturing Kurnool (IIITDM Kurnool) is a centrally funded technical institute established in 2015 by the Ministry of Education, Govt. of India. IIITDM Kurnool was accorded the status of an Institute of National Importance. The Hon'ble Prime Minister dedicated the institute to the nation on 20th February 2024.</p>
              <p className="home-text-paragraph home-text-justified">The institute is offering B.Tech. programmes in Computer Science Engineering, Artificial Intelligence and Data Science, Electronics and Communication Engineering (specialization: Design and Manufacturing), and Mechanical Engineering (specialization: Design and Manufacturing).</p>
              <p className="home-text-paragraph home-text-justified">M. Tech. programmes are offered in CSE, AI&DS, VLSI and Embedded Systems, IoT and Drones, Smart manufacturing, and Robotics and Automation. The institute is also offering Ph.D. programmes in emerging research areas such as Advanced Materials, Semiconductors, Quantum Technologies, Manufacturing & Industry 4.0, Hydrogen Energy, and more.</p>
               </div>
            <div className="home-image-content">
              <div className="home-placeholder-img home-campus-img">
                <div className="home-img-overlay">IIITDM Campus</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Department of Sciences */}
      <section className="home-section home-about-dos">
        <div className="home-container">
          <div className="home-section-header">
            <h2 className="home-section-title">
              About Department of Sciences
              <a href="https://iiitk.ac.in/Sciences-Faculty/page" target="_blank" rel="noopener noreferrer" className="home-external-link" title="Visit DoS Website">
                <FaExternalLinkAlt />
              </a>
            </h2>
          </div>
          <div className="home-content-grid">
            <div className="home-text-content">
              <p className="home-lead-text">The Department of Sciences (DoS) at IIITDM Kurnool is dedicated to advancing fundamental research and fostering interdisciplinary collaboration.</p>
              <p className="home-text-paragraph home-text-justified">The Department of Sciences at IIITDM Kurnool contains three divisions, namely Mathematics, Physics and English, with 14 faculty members. It offers basic/advanced core and elective Mathematics and Physics courses for B. Tech Programmes.</p>
              <p className="home-text-paragraph home-text-justified">Besides, the Department of Sciences also offers Ph.D. Programmes in the frontier areas of Mathematics, Physics, and English.</p>
            </div>
            <div className="home-image-content">
              <div className="home-placeholder-img home-research-img">
                <div className="home-img-overlay">Department Of Sciences</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
